import { inchesToCm } from "./formatBoxDimensions";
import {
  DEFAULT_ITEM_WEIGHT_GRAMS,
  gramsToKg,
  MIN_SHIPROCKET_WEIGHT_KG,
} from "./formatWeight";
import {
  computeShippingDimensionsInches,
  countCartBoxes,
} from "./shippingPackaging";

/**
 * Estimate parcel size/weight from cart line items for Shiprocket.
 * Weight: grams on products → kg for API.
 * Dimensions: collapsed shipping mailer (18×12×1.5 in, up to 5 boxes), not assembled box size.
 */
export function computeParcelFromCart(cart, paymentMethod = "Prepaid") {
  let totalWeightGrams = 0;

  for (const item of cart || []) {
    const qty = Math.max(1, Number(item.quantity) || 1);
    const itemWeightGrams = Number(item.weight);
    if (Number.isFinite(itemWeightGrams) && itemWeightGrams > 0) {
      totalWeightGrams += itemWeightGrams * qty;
    } else {
      totalWeightGrams += DEFAULT_ITEM_WEIGHT_GRAMS * qty;
    }
  }

  if (totalWeightGrams <= 0) totalWeightGrams = DEFAULT_ITEM_WEIGHT_GRAMS;

  let weightKg = gramsToKg(totalWeightGrams);
  if (!Number.isFinite(weightKg)) weightKg = gramsToKg(DEFAULT_ITEM_WEIGHT_GRAMS);
  weightKg = Math.max(MIN_SHIPROCKET_WEIGHT_KG, weightKg);

  const shipping = computeShippingDimensionsInches(countCartBoxes(cart));

  return {
    length: String(inchesToCm(shipping.length)),
    breadth: String(inchesToCm(shipping.breadth)),
    height: String(inchesToCm(shipping.height)),
    weight: String(weightKg),
    paymentMethod: String(paymentMethod || "Prepaid").toUpperCase() === "COD" ? "COD" : "Prepaid",
  };
}
